<template>
  <div class="warp">
    <!-- 顶部蓝色条 -->
    <div class="top">
      <span class="top_span">商户信息管理系统</span>
    </div>

    <div class="middle">
      <div class="see">用户信息查看</div>
    </div>

    <div class="table_value">
      <div class="one">
        <div class="small_tr">二维码编号：</div>
        <div class="small_big">{{news.qrNumber}}</div>
        <div class="small_tr">企业名称：</div>
        <div class="small_big_end">{{news.enterpriseName}}</div>
      </div>

      <div class="one">
        <div class="small_tr">是否签订责任书：</div>
        <div class="small_big">{{news.responsibilityFlag==="1"?"是" : "否"}}</div>
        <div class="small_tr">统一社会信用代码：</div>
        <div class="small_big_end">{{news.socialCreditNumber}}</div>
      </div>

      <div class="two">
        <div class="two_small_tr">经营范围：</div>
        <div class="two_small_big">{{news.businessScope}}</div>
      </div>

      <div class="one">
        <div class="small_tr">地址：</div>
        <div class="small_big">{{news.address}}</div>
        <div class="small_tr">所属社区：</div>
        <div class="small_big_end">{{news.belongCommunity}}</div>
      </div>

      <div class="one">
        <div class="small_tr">所属街道：</div>
        <div class="small_big">{{news.belongStreet}}</div>
        <div class="small_tr">责任人：</div>
        <div class="small_big_end">{{news.owner}}</div>
      </div>

      <div class="one">
        <div class="small_tr">责任人身份证号：</div>
        <div class="small_big">{{news.ownerIdentityNumber}}</div>
        <div class="small_tr">法定代表人电话：</div>
        <div class="small_big_end">{{news.legalRepresentativePhone}}</div>
      </div>

      <div class="one">
        <div class="small_tr">责任人联系电话：</div>
        <div class="small_big">{{news.ownerPhone}}</div>
       <div class="small_tr">所属网格：</div>
        <div class="small_big_end">{{news.belongGrid}}</div>

      </div>

      <div class="two two_end">
        <div class="two_small_tr">文字描述：</div>
        <div class="two_small_big">{{news.remark}}</div>
      </div>
    </div>

    <button @click="back()" class="btn">返回</button>
  </div>
</template>

<script>
export default {
  name: "informationview",
  data() {
    return {
      news:""
    }
  },
   created() {
    //接收传递过来的数据
    this.news=this.$route.query.viewPage
    console.log(this.$route.query.viewPage);
    console.log(this.news);

  },
  methods: {
    back() {
      this.$router.push({
        name: "home",
      });
    },
  },
};
</script>

<style scoped>
.warp {
  width: 100%;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
}
/* 顶部蓝色条 */
.top {
  width: 100%;
  height: 60px;
  background-color: #1f2942;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.top_span {
  height: 30px;
  font-family: MicrosoftYaHei;
  font-size: 0.07rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #fff;
  margin-left:20px;
  margin-bottom:20px;
}
.top_span_name {
  height: 0.03rem;
  font-family: MicrosoftYaHei;
  font-size: 0.04rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #ffffff;
  margin-right: 0.1rem;
}
/* 中间筛选部分 */
.middle {
	width: 950px;
	height: 20px;
  border-bottom: 0.001rem solid #1f6acb;
  position: absolute;
  top: 100px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

}
.see {
  font-family: MicrosoftYaHei-Bold;
  font-size: 15px;
  color: #1f6acb;

}

.table_value {

   width: 950px;
  height: 370px;
  border: 0.001rem solid #dfdfdf;
  position: absolute;
  top: 150px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
}
.one {
  border-bottom: 0.1px solid #dfdfdf;
  width: 950px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.two {
  height: 60px;
  width: 950px;

  border-bottom: 0.1px solid #dfdfdf;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.two_end {
  border-bottom: none;
}
.small_tr {
  width:160px;
  height:40px;
  border-right: 0.001rem solid #dfdfdf;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  font-family: MicrosoftYaHei;
  font-size: 0.03rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #333333;
}
.small_big {
  width:270px;
  height:40px;
  border-right: 0.001rem solid #dfdfdf;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #333333;
}
.small_big_end {
  width: 200px;
   height:40px;

  border-bottom: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-family: MicrosoftYaHei;
  font-size: 14px;

  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #333333;

}
.two_small_tr {
 
   width: 161px;
   height:61px;

  border-right: 0.1px solid #dfdfdf;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  font-family: MicrosoftYaHei;
  font-size: 0.03rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #333333;
}
.two_small_big {
   width: 795px;
   height:60px;
  border-right: none;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-family: MicrosoftYaHei;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #333333;
}
:focus{
    outline: 0;
}
.btn {
 width: 60px;
 height: 30px;
  border-radius: 0.01rem;
  border: solid 0.001rem #dfdfdf;

  font-family: MicrosoftYaHei;
  font-size: 0.03rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #333333;
  background: rgba(0, 0, 0, 0);
  margin-top: 0.11rem;
  position: absolute;
  top: 550px;
}
</style>



// WEBPACK FOOTER //
// src/components/informationview.vue